import React from 'react';
import { withRouter } from 'react-router-dom'

import css from './Edit.module.css';

import {
  Container,
  Grid,
  Button,
  FormControl,
  TextField,
} from '@material-ui/core';

import {
  Autocomplete,
} from '@material-ui/lab';

import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';


class Edit extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      files: this.getFilesArray(this.props.location.state.files),
      date: null,
      people: '',
      clinicCode: [],
      category: [],
      description: '',
    };
  }

  componentDidMount = () => {
  }

  getFilesArray = (files) => {
    const filesArray = [];
    for(const key in files)
      filesArray.push(files[key]);
    return filesArray;
  }

  handleStateChange = (key, value) => {
    this.setState({[key]: value});
  }

  resetForm = () => {
    this.setState({
      date: null,
      people: '',
      clinicCode: [],
      category: [],
      description: '',
    });
  }

  getUpdates = () => {
    let updates = {};
    if(this.state.date)
      updates.date = this.state.date.toISOString().substr(0, 10);
    if(this.state.people)
      updates.people = this.state.people;
    if(this.state.clinicCode.length > 0)
      updates.clinicCode = this.state.clinicCode.map((code) => code.value).join(', ');
    if(this.state.category.length > 0)
      updates.category = this.state.category.map((code) => code.value).join(', ');
    if(this.state.description)
      updates.description = this.state.description;
    return updates;
  }

  sendUpdates = (params) => {
    return new Promise(async (resolve, reject) => {
      try {
        let endpoint = `/api/upsert`;
        let response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(params),
        });
        let results = await response.json();
        return resolve(results);
      }
      catch(err) {
        return reject();
      }
    });
  }

  updateMetadata = async (metadata) => {
    try {
      await this.sendUpdates(metadata);
    } catch (err) {
      console.log('error creating File:', err);
    }
  }

  handleFormSubmit = async (e) => {
    e.preventDefault();
    this.props.alert('Confirm Update', 'Are you sure you want to submit these changes?', false, this.alertSubmitCallback);
  }

  getNewMetadata = (file, updates) => {
    const newMetadata = {};
    newMetadata.file_name = file.path;
    const payloadFields = [
      ['date', 'user_date'],
      ['clinicCode', 'clinic_code'],
      ['category', 'categories'],
      ['people', 'people'],
      ['description', 'description'],
      ['fileType', 'file_type'],
      ['uploadedBy', 'uploaded_by'],
    ];
    payloadFields.forEach((field) => {
      if(updates[field[0]] || file[field[0]])
        newMetadata[field[1]] = updates[field[0]] || file[field[0]];
    });
    return newMetadata;
  }

  alertSubmitCallback = async (result) => {
    if(!result)
      return this.props.alert('Update Canceled');

    let files = this.state.files;
    let updates = this.getUpdates();

    let noti = {
      id: `edit-${(new Date()).toISOString()}`,
      title: `Updating Metadata`,
      message: `0/${files.length} files updated`,
      status: 'pending',
      progress: 0,
    };
    await this.props.notiActions.add(noti);

    this.resetForm();
    this.props.alert(`Updating ${files.length} File(s)`, 'Please check the notification area for progress');

    for(let i = 0; i < files.length; ++i) {
      let newMetadata = this.getNewMetadata(files[i], updates);
      await this.sendUpdates(newMetadata);
      noti.message = `${i+1}/${files.length} files updated`;
      noti.progress = 100.0 * (i + 1) / files.length;
      noti.status = 'updating';
      await this.props.notiActions.update(noti);
    }
    noti.title = 'Updated Metadata';
    noti.status = 'done';
    await this.props.notiActions.update(noti);
  }

  render = () => {
    return (
      <form onSubmit={this.handleFormSubmit}>
        <Container>
          <br/>
          <Grid container spacing={2}>
            <Grid container item xs={7} spacing={2}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  disableToolbar
                  name="date"
                  variant="inline"
                  format="MM/dd/yyyy"
                  margin="normal"
                  id="date"
                  className="m-1 w-100"
                  label="Date"
                  value={this.state.date}
                  onChange={(date) => this.handleStateChange('date', date)}
                  autoOk={true}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </MuiPickersUtilsProvider>
              <FormControl className="w-100 m-1">
                <TextField 
                  labelId="people-input-label" 
                  id="standard-basic" 
                  label="People" 
                  value={this.state.people}
                  onChange={(event) => this.handleStateChange('people', event.target.value)}
                />
              </FormControl>
              
              <FormControl className="w-100 m-1">
                <Autocomplete
                  multiple
                  id="clinic-code-select"
                  options={this.props.clinicCodes}
                  getOptionLabel={(option) => `${option.value} - ${option.display}`}
                  groupBy={(option) => option.type}
                  value={this.state.clinicCode}
                  onChange={(event, newValue) => this.handleStateChange('clinicCode', newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      label="Clinic Code"
                      placeholder=""
                    />
                  )}
                />
              </FormControl>
              
              <FormControl className="w-100 m-1">
                <Autocomplete
                  multiple
                  id="category-select"
                  options={this.props.categories}
                  getOptionLabel={(option) => `${option.value} - ${option.display}`}
                  value={this.state.category}
                  onChange={(event, newValue) => this.handleStateChange('category', newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      label="Categories"
                      placeholder=""
                    />
                  )}
                />
              </FormControl>

              <FormControl className="w-100 m-1 mb-4">
                <TextField 
                  labelId="description-input-label" 
                  id="description" 
                  label="Description"
                  multiline={true}
                  rows={5}
                  value={this.state.description}
                  onChange={(event) => this.handleStateChange('description', event.target.value)}
                />
              </FormControl>
              
              <Button className="mr-2" type="submit" variant="contained">Update</Button>
              <Button onClick={() => this.resetForm()} variant="contained">Clear</Button>
            </Grid>

            <Grid item xs={5}>
              <div className={css.bold}>Selected Files:</div>
              <div>
                {this.state.files && this.state.files.map((file, index) =>
                  <div key={index}>{file.path}</div>
                )}
              </div>
            </Grid>
          </Grid>
        </Container>
      </form>
    );
  }
}

Edit.defaultProps = {
  clinicCodes: [
    // CLINIC
    {value: 'ASC', display: 'Ambulatory Surgery Center', type: 'Clinics'},
    {value: 'PAIN', display: 'Back and Neck Pain Center', type: 'Clinics'},
    {value: 'CMC', display: 'Comprehensive Memory Center', type: 'Clinics'},
    {value: 'DERM', display: 'Dermatology', type: 'Clinics'},
    {value: 'ENDO', display: 'Endocrinology', type: 'Clinics'},
    {value: 'INF', display: 'Infectious Disease', type: 'Clinics'},
    {value: 'LCI', display: 'Livestrong Cancer Institutes', type: 'Clinics'},
    {value: 'EYE', display: 'Mitchel and Shannon Wong Eye Institute', type: 'Clinics'},
    {value: 'MS', display: 'Multiple Sclerosis and Neuroimmunology Center', type: 'Clinics'},
    {value: 'MULV', display: 'Mulva Clinic for the Neurosciences', type: 'Clinics'},
    {value: 'MSK', display: 'Musculoskeletal Institute', type: 'Clinics'},
    {value: 'PRIM', display: 'Primary Care', type: 'Clinics'},
    {value: 'RHEUM', display: 'Rheumatology', type: 'Clinics'},
    {value: 'SURGONC', display: 'Surgical Oncology', type: 'Clinics'},
    {value: 'WI', display: 'Walk In', type: 'Clinics'},
    // ADULT PARTNER PROGRAMS
    {value: 'DM', display: 'Digestive Health', type: 'Adult Partner Programs'},
    {value: 'TC', display: 'Transplant Center', type: 'Adult Partner Programs'},
    {value: 'WH', display:"Women’s Health", type: 'Adult Partner Programs'},
    // PEDIATRIC PARTNER PROGRAMS
    {value: 'CFCC', display: 'Comprehensive Fetal Care Center', type: 'Pediatric Partner Programs'},
    {value: 'TCPCHD', display: 'Texas Center for Pediatric and Congenital Heart Disease', type: 'Pediatric Partner Programs'},
    {value: 'PEDIPRIM', display: 'Primary Pediatrics at Mueller', type: 'Pediatric Partner Programs'},
    {value: 'PEDINEURO', display: "UT Health Austin Pediatric Neurosciences at Dell Children's", type: 'Pediatric Partner Programs'},
    {value: 'PEDIPSYCH', display: "UT Health Austin Pediatric Psychiatry at Dell Children’s", type: 'Pediatric Partner Programs'},
    // ORGANIZATION
    {value: 'UTHA', display: 'UT Health Austin', type: 'Organizations'},
    {value: 'DCMC', display: "Dell Children’s Medical Center", type: 'Organizations'},
    {value: 'DMS', display: 'Dell Medical School', type: 'Organizations'},
    {value: 'ASCSTN', display: 'Ascension Seton', type: 'Organizations'},
  ],
  categories: [
    {value: 'patientStory', display: 'Patient Story'},
    {value: 'askFriend', display: 'Asking for a Friend'},
    {value: 'providerBio', display: 'Provider Bio Video'},
    {value: 'healthCuriosity', display: 'Healthy Curiosity'},
    {value: 'interview', display: 'Interview'},
    {value: 'surgeryProcedure', display: 'Surgery/Procedure'},
    {value: 'event', display: 'Event'},
  ],
};

export default withRouter(Edit);